import React from 'react'
import moment from 'moment'
import { Tooltip } from '@material-ui/core'

export const TimeTooltip = ({ time, children }) => {
  return (
    <Tooltip title={moment(time).format('DD MMM YYYY HH:mm')} placement="right" arrow>
      <span>
        {children}
      </span>
    </Tooltip>
  )
}